


import React, { Fragment } from "react";
import { useFormTypeByGuid } from "../../data/formType/useFormTypeByGuid";
import IFormType from "../../interfaces/IFormType";

type IRenderProps = { formType: IFormType };

interface RenderFormTypeByGuidProps {
    formTypeGuid: IFormType["guid"];
    render: (props: IRenderProps) => any;
};

export const RenderFormTypeByGuid: React.FC<RenderFormTypeByGuidProps> = ({ formTypeGuid, render }) => {
    const { data: formType } = useFormTypeByGuid(formTypeGuid);
    return (
        <Fragment>
            {render({ formType })}
        </Fragment>
    );
};

